export default __webpack_public_path__ + "static/media/default.184530ded65c79ef5781c0e1482a49b5.png";